<template>
    <div class="hpReg reveal">
        <div class="container">
            <div class="split-text title section-title">
                <p>REGISTRATION</p>
            </div>  
            <div class="reg-logo">
              <!-- <img src="img/svg/logo_1.svg" /> -->
              <img src="img/palma/shell.png" />
            </div>
            <div class="split-text fs16">
                <p>Join us in Palma de Mallorca</p>
            </div>  
            <div class="split-text fs16">
                <p>Reserve your spot!</p>
            </div>  
            <div class="xrBtn">
                <a class="base_btn reg_btn animation_up" target="_blank" 
                  href="https://web.cvent.com/event/bdfd78f5-cffd-41e3-8bae-d2ae73158323/register?RefId=MISCONFREG&rp=2ed1ffd3-005e-4650-b57d-729bc2aac6c4">
                  <span class="title">Register</span>
                  <i class="fal fa-chevron-right pl-s"></i>
                </a>
            </div>

        </div>
    </div>
</template>
<style>    
    .hpReg
    {
      width: 100%;
    }
    .hpReg .container
    {
      max-width: 1100px;
      width: 60vw;
    }
    .reg-logo
    {
      width: 35vw;
      margin: auto;
      text-align: center;
      max-width: 700px;   
      opacity: 0;   
      transition: all ease-in-out 0.7s;
      transition-delay: 0.3s;
      transform: scale(1.05);
    }
    .hpReg.reveal.active .reg-logo
    {
      transform: scale(1);
      opacity: 1;
    }
    .reg-logo img
    {
      width: 100%;
      height: auto;
      padding: 20px 0px;
    }

  @media (max-width: 850px) { 
    .hpReg .container
    {
      width: 85vw;
      padding: 0px;
    }
    .hpReg .container .title div
    {
      /* font-size: 24px !important;line-height: 30px; */
    }
    .reg-logo
    {
      width: 80vw;
      margin: auto;
      text-align: center;
    }


   }

</style>




<script>

export default {
  computed: {
    isMainVersion()
    {
        return this.$route.path.toLowerCase() == "/v2" ? false : true;
    }
  }
};
</script>
